import React from 'react'
import {
  UseOnChainRaffleType,
  UseOnChainUserRaffleType,
} from '../../techRaffles/hooks/hookTypes'
import { raffleType } from '../../techRaffles/types'
import {
  Badge,
  Box,
  Image,
  Link,
  ListItem,
  OrderedList,
  Text,
  useColorMode,
} from '@chakra-ui/react'
import { getBaseUrl } from '../../../config/config'

type RaffleHostPromotionProps = {
  raffle: raffleType
}

export const RaffleHostPromotionPage: React.FC<RaffleHostPromotionProps> = ({
  raffle,
}) => {
  const {colorMode} = useColorMode()
  const isDarkMode = colorMode === 'dark'
  const link = `${getBaseUrl()}/r/${raffle.id}`
  const tweetText = encodeURIComponent(
    `Raffling off ${raffle.name}!\n\nCheck it out: ${link}`
  )

  return (
    <>
      <Box
        mt='1rem'
        marginBottom='1rem'
        bg={isDarkMode ? 'cardBlack' : '#F9F9F9'}
        borderRadius='1.875rem'
        paddingY='1.5rem'
        paddingX='2.5rem'
      >
        <Text mb='1rem'>
          {raffle.createdTweetUrl && (
            <>
              Monet will support you with that - with posts in Discord and with{' '}
              <Link
                textDecor={'underline'}
                href={raffle.createdTweetUrl}
                target={'_blank'}
              >
                tweets about your raffle.
              </Link>
              <br></br>
            </>
          )}
          <br></br>
          We want your raffles to do well, so here are some helpful steps to
          promote your raffle in order to reach more people:
        </Text>

        <OrderedList textAlign={'left'} fontSize='1rem' spacing={'.8rem'} color={isDarkMode ? 'white' : 'black'}>
          <ListItem textAlign={'left'}>
            <b>Post about your raffle on Twitter</b> tagging the NFT, your
            community(s) and @MonetSAC.
            {'\t'}a. Add the <b>picture of the NFT</b> or the{' '}
            <b>graphic below</b> to that tweet.
            {'\t'}b. Possibly hold a giveaway to get more reach. (more details
            in the guide linked below)
          </ListItem>
          <ListItem textAlign={'left'}>
            You can visit the Discord of the project you're raffling off and
            notify them about the opportunity.
            {'\t'}a. Accept the project's token if possible. Add $ in front of
            the token in the tweet ($PUFF)
          </ListItem>
          <ListItem textAlign={'left'}>
            Feel free to promote your raffles in the Discord servers of the
            communities you tag, but do so respectfully. Never spam and use the
            appropriate channel if there is one available.
          </ListItem>
          <ListItem textAlign={'left'}>
            <b>Increase the amount of mentions</b> of your raffle on Twitter and
            Discord  <b>closer to the end.</b>
          </ListItem>
          {/*<ListItem>
      We also have two incredible options to boost your raffles Tweet (one is a custom version of Raven from BSL)
    </ListItem>*/}
          <ListItem textAlign={'left'}>
            Consider a giveaway of SOL or a token to get more reach on your
            tweet (more details in our guide below)
          </ListItem>
        </OrderedList>

        <Text mt='1.2rem'>
          We’ve <b>put together a document for you</b> with our best practice
          tips to promote your raffle.
          <br></br>Here you will find examples and more details on the above.
          <br></br>Check it out 👇
        </Text>
        <Link
          target='_blank'
          href='https://www.notion.so/sac-nft/Monet-How-to-promote-raffles-81ba3e45c04b4532bc7dcc6fba4369e0'
        >
          <Badge
            size='lg'
            mb='2rem'
            mt='1rem'
            mr='1rem'
            colorScheme='purple'
            fontSize='0.95rem'
            rounded='full'
            paddingY={1}
            paddingX={3}
          >
            Visit promotion guide
          </Badge>
        </Link>
        <Text>
          Don’t forget to post about this raffle using the image provided below
          or the image of the NFT.
        </Text>
        {raffle.newRaffleImageUrl && (
          <Badge
            _hover={{
              cursor: 'pointer',
            }}
            onClick={() =>
              window.open(raffle.newRaffleImageUrl?.toString(), '_blank')
            }
            size='lg'
            mb='2rem'
            mt='1rem'
            mr='1rem'
            colorScheme='gray'
            fontSize='0.95rem'
            rounded='full'
            paddingY={1}
            paddingX={3}
          >
            Download image
          </Badge>
        )}
        <Link
          target='_blank'
          href={`https://twitter.com/intent/tweet?text=${tweetText}`}
        >
          <Badge
            size='lg'
            mb='2rem'
            mt='1rem'
            colorScheme='blue'
            fontSize='0.95rem'
            rounded='full'
            paddingY={1}
            paddingX={3}
          >
            Tweet about raffle
          </Badge>
        </Link>

        <Image
          src={raffle.newRaffleImageUrl as string}
          maxWidth='420px'
          border={isDarkMode ? '1px solid #494949' : '1px solid #E2E8F0'}
          borderRadius='10px'
          mx='auto'
        />
      </Box>
    </>
  )
}
